import React, { useState, useEffect, useRef } from 'react';
import bidwit from './bidwit.png';
import carauc from './car auction.png';
import speedcubing from './speedcubing.png';
import DN from './DN2.png';
import Aquarace from './Aquarace.png';
import crossverse from './crossverse.png';
import cloud from './iot.png';
import roboliga from './roboliga.png';
import './Aar.css';

const cardData = [
  { id: 1, image: bidwit },
  { id: 2, image: carauc },
  { id: 3, image: speedcubing },
  { id: 4, image: DN },
  { id: 5, image: Aquarace },
  { id: 6, image: crossverse },
  { id: 7, image: cloud },
  { id: 8, image: roboliga },
];

const Aar = () => {
  const [headingInView, setHeadingInView] = useState(false);
  const [paragraphInView, setParagraphInView] = useState(false);
  const [cardsInView, setCardsInView] = useState(false);

  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  const cardsRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.target === headingRef.current) {
          setHeadingInView(entry.isIntersecting);
        }
        if (entry.target === paragraphRef.current) {
          setParagraphInView(entry.isIntersecting);
        }
        if (entry.target === cardsRef.current) {
          setCardsInView(entry.isIntersecting);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (headingRef.current) observer.observe(headingRef.current);
    if (paragraphRef.current) observer.observe(paragraphRef.current);
    if (cardsRef.current) observer.observe(cardsRef.current);

    return () => {
      if (headingRef.current) observer.unobserve(headingRef.current);
      if (paragraphRef.current) observer.unobserve(paragraphRef.current);
      if (cardsRef.current) observer.unobserve(cardsRef.current);
    };
  }, []);

  return (
    <div className="aar-container">
      <h1
        className={`aar-heading ${headingInView ? 'in-view' : ''}`}
        ref={headingRef}
      >
        AAROHAN
      </h1>
      <p
        className={`aar-paragraph ${paragraphInView ? 'in-view' : ''}`}
        ref={paragraphRef}
      >
        SAE plays a key role in supporting Team Aavishkar during Aarohan, the annual techno-management fest of NIT Durgapur. By combining strong technical expertise with the vibrant spirit of the fest, SAE helps create an engaging platform that promotes innovation and enhances technical skills.
      </p>
      <div
        className={`aar-cards ${cardsInView ? 'in-view' : ''}`}
        ref={cardsRef}
      >
        {cardData.map((card) => (
          <div key={card.id} className="aar-card">
            <img src={card.image} alt={`Card ${card.id}`} className="aar-card-image" />
          </div>
        ))}
      </div>
      <div className="aar-animated-line"></div>
    </div>
  );
};

export default Aar;
